<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['agent-change']);

const store = useStore();
const { t } = useI18n();

const allAgents = useMapGetter('agents/getAgents');
const selectedAgent = ref(null);

onMounted(() => {
  store.dispatch('agents/get');
});

const options = computed(() => [
  { id: null, name: t('PDV_SALES_REPORT.AGENT_FILTER.ALL') },
  ...allAgents.value,
]);

const onSelect = agent => {
  selectedAgent.value = agent;
  emit('agent-change', agent.id);
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedAgent"
      class="no-margin"
      track-by="id"
      label="name"
      :options="options"
      :placeholder="t('PDV_SALES_REPORT.AGENT_FILTER.PLACEHOLDER')"
      selected-label
      :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
      deselect-label=""
      :searchable="true"
      :allow-empty="false"
      @select="onSelect"
    />
  </div>
</template>
